<template>
  <div class="flex justify-center w-full sm:p-10">
    <div class="bg-white m-4 sm:w-full lg:max-w-2xl rounded-lg shadow-md">
      <ul class="flex border-b">
        <li class="-mb-px mr-1">
          <router-link
            class="inline-block border-l border-t border-r rounded-t py-2 px-4 text-orange-500 font-semibold"
            to="/newProduct"
          >Produkte</router-link>
        </li>
        <li class="-mb-px mr-1">
          <router-link
            class="inline-block border-b rounded-t py-2 px-4 text-green-800 font-semibold"
            to="/updatevendorinfo"
          >Hof</router-link>
        </li>
      </ul>

      <!-- form container -->

      <div class="w-full">
        <form class="p-4">
          <div class="w-full mb-6">
            <label
              class="block text-green-800 text-sm font-bold mb-2"
              for="Kategorie"
            >
              Kategorie
            </label>
            <div class="relative">
              <select
                v-model="newProduct.categorie"
                class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 focus:outline-none focus:shadow-outline"
              >
                <option
                  v-for="(categorie, index) in Categories"
                  :key="index"
                >{{categorie.text}}</option>
              </select>
              <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                <svg
                  class="fill-current h-4 w-4"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                >
                  <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" /></svg>
              </div>
            </div>
          </div>
          <div class="mb-4">
            <label
              class="block text-green-800 text-sm font-bold mb-2"
              for="name"
            >
              Produktname
            </label>
            <input
              class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
              type="text"
              placeholder="Name"
              v-model="newProduct.name"
            >
          </div>
          <div class="mb-4">
            <label
              class="block text-green-800 text-sm font-bold mb-2"
              for="subtitle"
            >
              Kurzbeschreibung
            </label>
            <input
              class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
              type="text"
              placeholder="Kurzbeschreibung"
              v-model="newProduct.subtitle"
            >
          </div>
          <div class="mb-4">
            <label
              class="block text-green-800 text-sm font-bold mb-2"
              for="unit"
            >
              Einheit <span class="text-xs text-gray-700"> (z.B. "Stück" oder "250ml")</span>
            </label>
            <input
              class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
              type="text"
              placeholder="Einheit"
              v-model="newProduct.unit"
            >
          </div>
          <label
            class="block text-green-800 text-sm font-bold mb-2"
            for="subtitle"
          >
            Preis
          </label>
          <div class="flex mb-4">

            <input
              class="mr-4 shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
              type="text"
              placeholder="Euro"
              v-model="newProduct.price.euro"
            >

            <input
              class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
              type="text"
              placeholder="Cent"
              v-model="newProduct.price.cent"
            >
          </div>
          <div class="mb-8">
            <label
              class="block text-green-800 text-sm font-bold mb-2"
              for="image"
            >
              Link zum Foto
            </label>
            <input
              class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
              type="text"
              placeholder="Foto-Link"
              v-model="newProduct.imageUrl"
            >
          </div>

          <!-- additional info -->

          <p
            class="block text-green-800 text-l font-bold mb-2"
            @click="addInfo = !addInfo"
          >*** Zusatzinformationen ***</p>

          <div
            v-if="addInfo"
            class="p-8"
          >

            <div class="mb-8">
              <label
                class="block text-green-800 text-sm font-bold mb-2"
                for="zutaten"
              >
                Zutaten
              </label>
              <input
                class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                type="text"
                placeholder="Zutaten mit Komma auflisten"
                v-model="newProduct.ingredients"
              >
            </div>
            <div class="mb-8">
              <label
                class="block text-green-800 text-sm font-bold mb-2"
                for="image"
              >
                Alkohol
              </label>
              <input
                class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                type="text"
                placeholder="Alkoholgehalt"
                v-model="newProduct.alcohol"
              >
            </div>

            <div class="mb-8">
              <label
                class="block text-green-800 text-sm font-bold mb-2"
                for="image"
              >
                Allergene
              </label>
              <input
                class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                type="text"
                placeholder="z.B. Milchzucker oder Sellerie"
                v-model="newProduct.allergens"
              >
            </div>

            <div class="mb-8">
              <label
                class="block text-green-800 text-sm font-bold mb-2"
                for="image"
              >
                Verwendung
              </label>
              <input
                class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                type="text"
                placeholder="z.B. Kühlung bei bestimmter Temperatur"
                v-model="newProduct.usage"
              >
            </div>
            <div class="mb-8">
              <label
                class="block text-green-800 text-sm font-bold mb-2"
                for="image"
              >
                Nährwerte
              </label>
              <table class="table-auto text-gray-700 text-sm mt-3">
                <thead>
                  <tr class="bg-gray-100">
                    <th class="border px-4 py-2">Nährstoffe</th>
                    <th class="border px-4 py-2">Menge auf 100g oder ml</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td class="border px-4 py-2">Kalorien</td>
                    <td class="border px-4 py-2"><input
                        type="text"
                        placeholder="z.B. 140 kcal"
                        v-model="nutrients.calories"
                      ></td>

                  </tr>
                  <tr>
                    <td class="border px-4 py-2">Fett</td>
                    <td class="border px-4 py-2"><input
                        type="text"
                        placeholder="z.B. 1,1 g"
                        v-model="nutrients.fat"
                      ></td>

                  </tr>
                  <tr>
                    <td class="border px-4 py-2">gesättigte Fettsäuren</td>
                    <td class="border px-4 py-2"><input
                        type="text"
                        placeholder="z.B. 0,2 g"
                        v-model="nutrients.acids"
                      ></td>

                  </tr>
                  <tr>
                    <td class="border px-4 py-2">Zucker</td>
                    <td class="border px-4 py-2"><input
                        type="text"
                        placeholder="z.B. 4 g"
                        v-model="nutrients.sugar"
                      ></td>

                  </tr>

                  <tr>
                    <td class="border px-4 py-2">Kohlenhydrate</td>
                    <td class="border px-4 py-2"><input
                        type="text"
                        placeholder="z.B. 2, 0g"
                        v-model="nutrients.carbs"
                      ></td>

                  </tr>
                  <tr>
                    <td class="border px-4 py-2">Eiweiß</td>
                    <td class="border px-4 py-2"><input
                        type="text"
                        placeholder="z.B. 4,9 g"
                        v-model="nutrients.protein"
                      ></td>

                  </tr>
                </tbody>
              </table>
            </div>

          </div>

          <div class="flex justify-between mt-4">

            <button
              @click="onSubmit"
              class="bg-green-800 hover:bg-green-500 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
              type="button"
            >
              Senden
            </button>
            <button
              @click="clearForm"
              class="bg-orange-800 hover:bg-orange-500 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
              type="button"
            >
              Löschen
            </button>

          </div>

        </form>

      </div>
      <!-- List of existing products   -->

      <hr class="mb-8">

      <div
        class="flex my-2 mx-4 p-3 justify-between border rounded text-green-700"
        v-for="(product,index) in products"
        :key="index"
      >
        <div>{{product.name}}</div>
        <div
          class="flex"
          @click="deleteProduct(product.id, index)"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            width="24"
            height="24"
          >
            <path
              class="heroicon-ui fill-current text-red-800"
              d="M8 6V4c0-1.1.9-2 2-2h4a2 2 0 0 1 2 2v2h5a1 1 0 0 1 0 2h-1v12a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V8H3a1 1 0 1 1 0-2h5zM6 8v12h12V8H6zm8-2V4h-4v2h4zm-4 4a1 1 0 0 1 1 1v6a1 1 0 0 1-2 0v-6a1 1 0 0 1 1-1zm4 0a1 1 0 0 1 1 1v6a1 1 0 0 1-2 0v-6a1 1 0 0 1 1-1z"
            /></svg>
        </div>

      </div>
    </div>

  </div>
</template>

<script>
import firebase from "firebase/app";
import "firebase/auth";
import db from "./firebaseinit";
export default {
  data() {
    return {
      products: [],
      user_id: "",
      vendor: [],
      newProduct: {
        name: "",
        categorie: "",
        subtitle: "",
        unit: "",
        price: {
          euro: null,
          cent: null
        },
        imageUrl: "",
        alcohol: "",
        allergens: "",
        usage: "",
        ingredients: ""
      },
      Categories: [],
      addInfo: false,
      nutrients: {
        calories: "",
        fat: "",
        acids: "",
        sugar: "",
        carbs: "",
        protein: ""
      }
    };
  },
  created() {
    // get categories from db
    this.user_id = firebase.auth().currentUser.uid;
    var self = this.Categories;
    db.collection("categories")
      .get()
      .then(function(querySnapshot) {
        querySnapshot.forEach(function(doc) {
          var data = doc.data();
          data.id = doc.id;
          self.push(data);
        });
      });
    // get existing products from db
    this.getProducts();
    // get name of Vendor
    this.getVendorName();
  },
  methods: {
    onSubmit() {
      let self = this.newProduct;
      function findLink(link) {
        return link.text === self.categorie;
      }
      let categorieLink = this.Categories.find(findLink);
      let newCategorie = categorieLink.link;
      let newProduct = {
        categorie: newCategorie,
        name: this.newProduct.name,
        subtitle: this.newProduct.subtitle,
        unit: this.newProduct.unit,
        price: parseFloat(
          this.newProduct.price.euro + "." + this.newProduct.price.cent
        ).toFixed(2),
        image: this.newProduct.imageUrl,
        user_id: this.user_id,
        vendor: this.vendor[0],
        ingredients: this.newProduct.ingredients,
        allergens: this.newProduct.allergens,
        alcohol: this.newProduct.alcohol,
        usage: this.newProduct.usage,
        nutrients: {
          caloriens: this.nutrients.calories,
          fat: this.nutrients.fat,
          acids: this.nutrients.acids,
          sugar: this.nutrients.sugar,
          carbs: this.nutrients.carbs,
          protein: this.nutrients.protein
        }
      };
      db.collection("products")
        .add(newProduct)
        .then(() => {
          this.clearForm();
          this.products = [];
          this.getProducts();
        });
    },
    clearForm() {
      (this.newProduct.categorie = ""),
        (this.newProduct.name = ""),
        (this.newProduct.subtitle = ""),
        (this.newProduct.unit = ""),
        (this.newProduct.price.euro = null),
        (this.newProduct.price.cent = null),
        (this.newProduct.imageUrl = "");
    },
    deleteProduct(id, index) {
      let res = confirm("Willst Du das Produkt wirklich löschen?");

      if (res) {
        db.collection("products")
          .doc(id)
          .delete()
          .then(() => {
            this.products.splice(index, 1);
          })
          .catch(function(error) {
            console.error("Error removing document: ", error);
          });
      }
    },
    // get existing products from db

    getProducts() {
      var products = this.products;
      db.collection("products")
        .where("user_id", "==", firebase.auth().currentUser.uid)
        .get()
        .then(function(querySnapshot) {
          querySnapshot.forEach(function(doc) {
            var data = doc.data();
            data.id = doc.id;
            products.push(data);
          });
        });
    },

    // get vendor name
    getVendorName() {
      var vendor = this.vendor;
      db.collection("vendor")
        .where("user_id", "==", firebase.auth().currentUser.uid)
        .get()
        .then(function(querySnapshot) {
          querySnapshot.forEach(function(doc) {
            vendor.push(doc.data().name);
          });
        });
    }
  }
};
</script>

<style lang="scss" scoped>
</style>